import { ApolloLink, Observable } from "apollo-link";
import { getToken, setToken } from "./apollo-token";
import { getMobileToken, setMobileToken } from "./apollo-token-mobile";
import { redirectToLogin } from "../router/auth-hooks";
import { getDeviceFingerprint } from "../components/authentication/useUser";
import { isPublicOperation } from "./public-operations";

export default function createAuthLinkBO() {
  return new ApolloLink((operation, forward) => {
    const isMobilePage =
      ["/mobile-inventory", "/mobile-manage-overlock"].includes(
        window.location.pathname
      ) ||
      (window.location.pathname.includes("/manage-tasks/") &&
        (window.location.pathname.includes("/manage-overlock") ||
          window.location.pathname.includes("/remove-overlock") ||
          window.location.pathname.includes("/pre-install")));

    let headers = operation.getContext().headers || {};

    headers = {
      ...headers,
      "x-device-id": getDeviceFingerprint(),
    };

    operation.setContext({
      headers: headers,
    });

    const token = isMobilePage ? getMobileToken() : getToken();

    if (token) {
      operation.setContext({
        headers: {
          ...headers,
          authorization: token ? `Bearer ${token}` : "",
        },
      });
    } else if (!isPublicOperation(operation.operationName) && !isMobilePage) {
      redirectToLogin();
      const data = {};
      for (const field of extractFieldNames(operation)) {
        data[field] = null;
      }
      return Observable.of({ data });
    }

    const observable = forward(operation);
    const redirectObservable = observable.map((result) => {
      if (
        operation.operationName === "AuthenticateUser" &&
        result.data?.login?.token
      ) {
        setToken(result.data.login.token);
      } else if (
        operation.operationName === "authenticateWithQrToken" &&
        result.data?.authenticateWithQrToken?.token
      ) {
        setMobileToken(result.data.authenticateWithQrToken.token);
      } else if (
        result?.errors?.some(
          (graphQLError) => graphQLError.message == "not_authenticated"
        ) &&
        !isMobilePage
      ) {
        redirectToLogin();
      }
      return result;
    });
    return redirectObservable;
  });
}

function extractDefinition(operation) {
  return operation.query.definitions.find(
    (q) => q.kind === "OperationDefinition"
  );
}

function extractFieldNames(operation) {
  const definition = extractDefinition(operation);
  return definition?.selectionSet?.selections?.reduce(
    (acc, fieldDefinition) => {
      if (fieldDefinition?.kind === "Field" && fieldDefinition?.name?.value) {
        acc.push(fieldDefinition.name.value);
      }
      return acc;
    },
    []
  );
}
